export enum ETipoParametro{
  Boolean = 1,
  Inteiro = 2,
  Real = 3,
  Texto = 4,
  Lista = 5,
  ListaRecursoReferenciado = 6,
}
